import * as actionTypes from './actionTypes';

export const initProfileForm = (UserId, ThumbURL, FirstName, LastName, NickName, DateBirthDay, Color, ProfileStatus, isManagedUser, ShowModal) => {
  return {
    type: actionTypes.INIT_PROFILE_FORM,
    UserId,
    ThumbURL,
    FirstName,
    LastName,
    NickName,
    DateBirthDay,
    Color,
    ProfileStatus,
    isManagedUser,
    ShowModal,
  };
};

export const closeProfileForm = () => {
  return {
    type: actionTypes.CLOSE_PROFILE_FORM,
  };
};

export const uploadProfileImage = (profileImage) => {
  return {
    type: actionTypes.UPLOAD_PROFILE_IMAGE,
    profileImage,
  };
};

export const uploadProfileImageStart = () => {
  return {
    type: actionTypes.UPLOAD_PROFILE_IMAGE_START,
  };
};

export const uploadProfileImageFailed = (error) => {
  return {
    type: actionTypes.UPLOAD_PROFILE_IMAGE_FAILED,
    error,
  };
};

export const setProfileImage = (profileImageId, ImageURL, ThumbURL) => {
  return {
    type: actionTypes.SET_PROFILE_IMAGE,
    profileImageId,
    ImageURL,
    ThumbURL,
  };
};

export const submitProfileStart = () => {
  return {
    type: actionTypes.SUBMIT_PROFILE_START,
  };
};

export const submitProfileSuccess = (User, Logs, ProfileStatus) => {
  return {
    type: actionTypes.SUBMIT_PROFILE_SUCCESS,
    User,
    Logs,
    ProfileStatus,
  };
};

export const submitProfileFailed = (error) => {
  return {
    type: actionTypes.SUBMIT_PROFILE_FAILED,
    error,
  };
};

export const fetchProfileSuccess = (
  User,
  Logs,
  ManagedUsers,
  Groups,
  isManagedUser,
  userStatus,
  giftsDraftsCount,
  KnownUsers,
  postingAsSameAsSignedInAs,
  emojiSkinTone,
) => {
  return {
    type: actionTypes.FETCH_PROFILE_SUCCESS,
    User,
    Logs,
    ManagedUsers,
    Groups,
    isManagedUser,
    userStatus,
    giftsDraftsCount,
    KnownUsers,
    postingAsSameAsSignedInAs,
    emojiSkinTone,
  };
};

export const editEmojiTone = (emojiSkinTone) => {
  return {
    type: actionTypes.USER_EDIT_EMOJI_TONE,
    emojiSkinTone,
  };
};

export const fetchProfileFailed = (error) => {
  return {
    type: actionTypes.FETCH_PROFILE_FAILED,
    error,
  };
};

export const fetchProfileStart = () => {
  return {
    type: actionTypes.FETCH_PROFILE_START,
  };
};

export const fetchProfileReturnsNewUser = (UserId) => {
  return {
    type: actionTypes.FETCH_PROFILE_RETURNS_NEW_USER,
    UserId,
  };
};

export const setManagedUsers = (managedUsers) => {
  return {
    type: actionTypes.SET_MANAGED_USERS,
    managedUsers,
  };
};

export const updateEmail = (Email) => {
  return {
    type: actionTypes.UPDATE_EMAIL,
    Email,
  };
};

export const updateEmailStart = () => {
  return {
    type: actionTypes.UPDATE_EMAIL_START,
  };
};

export const updateEmailSuccess = (Email) => {
  return {
    type: actionTypes.UPDATE_EMAIL_SUCCESS,
    Email,
  };
};

export const updateEmailFailed = (error) => {
  return {
    type: actionTypes.UPDATE_EMAIL_FAILED,
    error,
  };
};

export const updatePassword = (OldPassword, NewPassword) => {
  return {
    type: actionTypes.UPDATE_PASSWORD,
    OldPassword,
    NewPassword,
  };
};

export const updatePasswordStart = () => {
  return {
    type: actionTypes.UPDATE_PASSWORD_START,
  };
};

export const updatePasswordSuccess = () => {
  return {
    type: actionTypes.UPDATE_PASSWORD_SUCCESS,
  };
};

export const updatePasswordFailed = (error) => {
  return {
    type: actionTypes.UPDATE_PASSWORD_FAILED,
    error,
  };
};

export const updatePostingAs = (UserId) => {
  localStorage.setItem('postingAs', JSON.stringify({ UserId }));
  return {
    type: actionTypes.UPDATE_POSTING_AS,
    UserId,
  };
};

export const revertToSignedInAs = () => {
  return {
    type: actionTypes.REVERT_TO_SIGNED_IN_AS,
  };
};

export const createManagedAccountStart = () => {
  return {
    type: actionTypes.CREATE_MANAGED_ACCOUNT_START,
  };
};

export const createManagedAccountFailed = (error) => {
  return {
    type: actionTypes.CREATE_MANAGED_ACCOUNT_FAILED,
    error,
  };
};

export const createManagedAccountSuccess = (UserId) => {
  return {
    type: actionTypes.CREATE_MANAGED_ACCOUNT_SUCCESS,
    UserId,
  };
};

export const deleteManagedAccount = (UserId) => {
  return {
    type: actionTypes.DELETE_MANAGED_ACCOUNT,
    UserId,
  };
};

export const deleteManagedAccountStart = () => {
  return {
    type: actionTypes.DELETE_MANAGED_ACCOUNT_START,
  };
};

export const deleteManagedAccountFailed = (error) => {
  return {
    type: actionTypes.DELETE_MANAGED_ACCOUNT_FAILED,
    error,
  };
};

export const deleteManagedAccountSuccess = (UserId) => {
  return {
    type: actionTypes.DELETE_MANAGED_ACCOUNT_SUCCESS,
    UserId,
  };
};

export const userSearch = (SearchFor) => {
  return {
    type: actionTypes.USER_SEARCH,
    SearchFor,
  };
};

export const userSearchStart = () => {
  return {
    type: actionTypes.USER_SEARCH_START,
  };
};

export const userSearchSuccess = (users) => {
  return {
    type: actionTypes.USER_SEARCH_SUCCESS,
    users,
  };
};

export const userSearchFailed = (error) => {
  return {
    type: actionTypes.USER_SEARCH_FAILED,
    error,
  };
};
